/**
 * Adds class to the `body` and shows a loading indicator.
 */
export function startLoadingAnimation(internal = false) {
	// 🔥 NEW: Automatically trigger loader for ANY "/pages/..." URL
	if (location.pathname.startsWith("/pages/")) {
		document.body.classList.add("lta-loader");
		if (internal) {
			document.body.classList.add("lta-loader--internal");
		} else {
			document.body.classList.remove("lta-loader--internal");
		}
		return; // Stop here — already matched
	}

	// 🔥 Existing logic for items explicitly listed in LOADER_PAGES
	for (let i = 0; i < LOADER_PAGES.length; i++) {
		if ((new RegExp(LOADER_PAGES[i])).test(location.pathname)) {	  
			document.body.classList.add('lta-loader');
			if(internal) {
				document.body.classList.add('lta-loader--internal');
			} else {
				document.body.classList.remove('lta-loader--internal');
			}
			return;
		}
	}
}
/**
 * Mutates the dom to froce stop the loading indicator.
 */
export function stopLoadingAnimation() {
	document.body.classList.remove('lta-loader');
	document.body.classList.remove('lta-loader--internal');
}
